/**
 * Main entry point — bundled by esbuild to public/assets/js/main.js
 */

declare const Phaser: any;

import { SceneManager } from "./framework/SceneManager";
import { EventBus } from "./framework/EventBus";
import { AudioManager } from "./framework/AudioManager";
import { AssetManager } from "./framework/AssetManager";
import { FullscreenManager } from "./framework/FullscreenManager";

import { createRunState } from "./game/data/RunState";
import { WordService } from "./game/services/WordService";
import { MapScene } from "./game/scenes/MapScene";
import { BattleScene } from "./game/scenes/BattleScene";
import { ShopScene } from "./game/scenes/ShopScene";
import { TreasureScene } from "./game/scenes/TreasureScene";
import { RestScene } from "./game/scenes/RestScene";
import { EventScene } from "./game/scenes/EventScene";
import { WorldScene } from "./game/WorldScene";

const container = document.getElementById("game-container");
if (container && typeof Phaser !== "undefined") {
  // Load word data, then start game
  const wordService = new WordService();
  wordService.init().then(() => {
    const game = new Phaser.Game({
      type: Phaser.AUTO,
      width: 800,
      height: 450,
      parent: "game-container",
      backgroundColor: "#0f1b2d",
      scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        fullscreenTarget: container,
      },
      physics: {
        default: "arcade",
        arcade: {
          gravity: { x: 0, y: 0 },
          debug: false,
        },
      },
      scene: [MapScene, BattleScene, ShopScene, TreasureScene, RestScene, EventScene, WorldScene],
    });

    // Store singletons in registry so all scenes can access them
    game.registry.set("sceneManager", new SceneManager(game, "MapScene"));
    game.registry.set("eventBus", new EventBus());
    game.registry.set("runState", createRunState());
    game.registry.set("createRunState", createRunState);
    game.registry.set("wordService", wordService);

    // Framework singletons (game modules register their own assets/tones)
    game.registry.set("assets", new AssetManager(game));
    game.registry.set("audio", new AudioManager(game));
    game.registry.set("fullscreen", new FullscreenManager(game));
  }).catch((err) => {
    console.error("Failed to load word data:", err);
  });
}
